import map from 'lodash/map'
import * as React from 'react'
import {H3, H4} from '@frontrow/console/src/components/typography'
import {
  type SyncResultSuccessT,
  type LogPairT
} from '@frontrow/console/src/entities/models/roster-sync'

type Props = {
  stats: SyncResultSuccessT
}

export default function RosterSyncSuccessFailure(props: Props): React.ReactElement {
  const {stats} = props
  const {failedItems} = stats
  const failures = [
    ...map(failedItems.failedStudents, (logPair, i: number) => (
      <LogMessage key={`${i}1`} entityType="Student" logPair={logPair} />
    )),
    ...map(failedItems.failedTeachers, (logPair, i: number) => (
      <LogMessage key={`${i}2`} entityType="Teacher" logPair={logPair} />
    )),
    ...map(failedItems.failedCourses, (logPair, i: number) => (
      <LogMessage key={`${i}3`} entityType="Course" logPair={logPair} />
    )),
    ...map(failedItems.failedCourseMemberships, (logPair, i: number) => (
      <LogMessage key={`${i}4`} entityType="Course membership" logPair={logPair} />
    ))
  ]
  return (
    <React.Fragment>
      <H3>
        Failures in {stats.schoolName} ({stats.schoolIdpId})
      </H3>
      {failures}
    </React.Fragment>
  )
}

type LogMessageProps = {
  entityType: string
  logPair: LogPairT
}

function LogMessage({entityType, logPair}: LogMessageProps): React.ReactElement {
  const courseId = logPair.courseId !== undefined ? <h5>Course: {logPair.courseId}</h5> : null
  const studentId = logPair.studentId !== undefined ? <h5>Student: {logPair.studentId}</h5> : null
  return (
    <React.Fragment>
      <H4>
        {entityType} {logPair.idpId}
      </H4>
      {courseId}
      {studentId}
      <pre>{logPair.logMessage.message}</pre>
    </React.Fragment>
  )
}
